// extracted by mini-css-extract-plugin
export var arrow = "imageCarousel-module--arrow--Gz4CV";
export var bullet = "imageCarousel-module--bullet--bZsbm";
export var bullets = "imageCarousel-module--bullets--IcbXz";
export var container = "imageCarousel-module--container--xmb5m";
export var left = "imageCarousel-module--left--rcpXi";
export var right = "imageCarousel-module--right--5xH3k";
export var shopButton = "imageCarousel-module--shop-button--Y3eNM";
export var slide = "imageCarousel-module--slide--kfqPv";